module.exports = __webpack_public_path__ + "b51a7ab3855741d54fd2ef2f35275161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/pic8.png
// module id = 1867
// module chunks = 0